import { Navigate, Outlet } from "react-router-dom";
import SecondarySidebarLayout from "components/wrappers/SecondarySidebarLayout";
import Attendance from "pages/Calender/Attendance";
import Overtime from "pages/Calender/Overtime";
import LeaveBalance from "pages/Calender/LeaveBalance";
import usePermissions from "hooks/usePermission";
import filterByPermissions from "utils/filterByPermissions";
import ProtectedOutlet from "components/wrappers/ProtectedOutlet";
import { PermissionCodename } from "constants/permission";

interface clenderTypes {
  path: string;
  element: JSX.Element;
  permission?: PermissionCodename;
}

export default function CalenderRoutes() {
  const { hasPermissionTo } = usePermissions();

  const rawChildren: clenderTypes[] = [
    {
      path: "attendance",
      permission: "view_staff_attendance",
      element: (
        <ProtectedOutlet requiredPermission="view_staff_attendance">
          <Attendance />
        </ProtectedOutlet>
      ),
    },
    {
      path: "leave balance",
      permission: "view_staff_leave_balance",
      element: (
        <ProtectedOutlet requiredPermission="view_staff_leave_balance">
          <LeaveBalance />
        </ProtectedOutlet>
      ),
    },
    {
      path: "overtime",
      permission: "view_staff_overtime",
      element: (
        <ProtectedOutlet requiredPermission="view_staff_overtime">
          <Overtime />
        </ProtectedOutlet>
      ),
    },
  ];

  const filteredList = filterByPermissions(rawChildren, hasPermissionTo);
  const defaultPath = filteredList.length > 0 ? filteredList[0].path : "attendance";

  const children: any[] = [
    {
      path: "",
      element: <Navigate to={defaultPath} />,
    },
    ...rawChildren,
  ];

  return {
    path: "calendar",
    element: (
      <SecondarySidebarLayout list={filteredList} title="">
        <Outlet />
      </SecondarySidebarLayout>
    ),
    children,
  };
}
